/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface OneDWaterLevelPredefined
 */
export interface OneDWaterLevelPredefined {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the OneDWaterLevelPredefined interface.
 */
export function instanceOfOneDWaterLevelPredefined(
  value: object
): value is OneDWaterLevelPredefined {
  return true;
}

export function OneDWaterLevelPredefinedFromJSON(json: any): OneDWaterLevelPredefined {
  return OneDWaterLevelPredefinedFromJSONTyped(json, false);
}

export function OneDWaterLevelPredefinedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OneDWaterLevelPredefined {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function OneDWaterLevelPredefinedToJSON(json: any): OneDWaterLevelPredefined {
  return OneDWaterLevelPredefinedToJSONTyped(json, false);
}

export function OneDWaterLevelPredefinedToJSONTyped(
  value?: Omit<OneDWaterLevelPredefined, "url" | "simulation" | "uid" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {};
}
